<template>
    <h3 class="text-danger"><i class="bi bi-people-fill me-1"></i> Unspecified Voters</h3>
    <div class="form-group">
        <select @change="getUnspecified" class="form-select" v-model="cityId">
            <option v-for="city in cities" :value="city.id_mun" :key="city.id_mun">{{ city.name_mun }}</option>
        </select>
    </div>
    <div class="table-responsive">
    <table class="table">
        <thead>
            <tr>
                <th class="text-center">Municipal</th>
                <th class="text-center">Barangay</th>
                <th class="text-center">Qty</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(brgy,index) in brgys" :key="index">
                <td>{{ brgy.cityname }}</td>
                <td>{{ brgy.brgyname }}</td>
                <td>{{ brgy.qty }}</td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script setup>
import areaService from '@/services/areaService';
import reportService from '@/services/reportService';
import spinnerService from '@/services/spinnerService';
import { onMounted, ref } from 'vue';
const brgys = ref([]);
const cityId = ref(0);
const cities = ref([]);
const getUnspecified = async ()=>{
    spinnerService.show();
    brgys.value = await reportService.getUnspecified(cityId.value);
    spinnerService.hide();
}

const getCities = async()=>{
    cities.value = await areaService.getMunicipalities();
    if(cities.value.length === 1){
        cityId.value = cities.value[0].id_mun;
    }
    else if(cities.value.length > 1){
        cityId.value = cities.value[1].id_mun;
    }
    getUnspecified();

}

onMounted(()=>{
    getCities();
})
</script>